(function ($) {

    $(document).ready(function () {

        if ($('.graphic-wrap').length) {

            $(".graphic-wrap .popup-btn").on("click", function() {
                console.log("1111111");
                var popup = $(this).data('popup');
                $(".popup:not(." + popup + ")").fadeOut('slow');
                $('.popup.' + popup).fadeIn('slow');
            });

            $(".popup .close").on('click', function () {
                $(this).parent('.popup').fadeOut('slow');
            });

        }

        $(document).on('mouseup touchend', function (e) {
             var popup = $(".popup");
             if (!popup.is(e.target) && popup.has(e.target).length === 0) {
                 popup.fadeOut('slow');
             }
         });

    });

})(jQuery);


// WEBPACK FOOTER //
// ./src/js/custom/emergent_graphic.es6